const fetchItem = async (id) => {
    const tipo = document.querySelector('.main__filtros .btn--active').id;

   try {
    const url =`https://api.themoviedb.org/3/${tipo}/${id}?api_key=71215a991e35e69723fc495d6d25c8fc&language=es-ARG`;
    const respuesta = await fetch (url);
    const datos = await respuesta.json();

    return datos;

   } catch (e){
    console.log(e);
   }
};

export default fetchItem;
